import { render } from "./dropdownButton.vue?vue&type=template&id=0ccca172"
import script from "./dropdownButton.vue?vue&type=script&lang=js"
export * from "./dropdownButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__